<template>
    <v-row wrap class="pa-1 pa-sm-0">
        <v-col cols="12">
            <grid-resources
                heading="Stays"
                view-name="stays"
                :desc="category.Description"
                :card-props="{ cardClass: category.CardClass, contain: category.ContainImg }"
                :limit="200" />
            <modal-details />
        </v-col>
        <v-col cols="12">
            <Footer />
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { Footer, GridResources, ModalDetails  } from '@/components'

export default {
    data: () => ({
        themes: [],
    }),
    components: {
        GridResources,
        ModalDetails,
        Footer,
    },
    methods: {
    },
    computed: {
        ...mapState({
            users: state => state.user.all,
            category: state => state.category.all.filter(c=>c.Name === 'Stays'),
            dialogDetails: state => state.resource.dialogDetails,
        }),
        ...mapGetters([
            'isLoggedIn',
        ])
    }
}
</script>
<style scoped>
    .sticky-top {
        position: sticky;
        top: 70px;
        z-index: 3;
    }
</style>